<app-leveltwo [pageName]="'Language Access Services'">
  <div heading="General Info" class="General">
    <h3>{{'LanguageAccess.SearchTitle'|translate}}</h3>
    <p [innerHTML]="'LanguageAccess.TheLosAngeles'|translate"></p>
    <h4>{{'LanguageAccess.DLAP'|translate}}</h4>
    <p [innerHTML]="'LanguageAccess.DLAPText'|translate"></p>
    <h4>{{'LanguageAccess.LanguageAccessComplaintForm'|translate}}</h4>
    <p [innerHTML]="'LanguageAccess.Wearecommitted'|translate"></p>
    <p [innerHTML]="'LanguageAccess.Oncesubmitted'|translate"></p>
    <p [innerHTML]="'LanguageAccess.Youmaysubmitv2'|translate"></p>
    <ul>
      <!-- <li><strong>Email: </strong><a href="mailto:DLAP@assessor.lacounty.gov" target="_blank">DLAP&#64;assessor.lacounty.gov</a></li>
      <br> -->
      <li><strong>Mail: </strong><br>
        Assessor Departmental Language Assistance Program<br>
        500 W. Temple Street, Room 350<br>
        Los Angeles, CA 90012</li>
    </ul>

    <p [innerHTML]="'LanguageAccess.Ifyouhave'|translate"></p>
  </div>

</app-leveltwo>
